import React from 'react';
import { Box, Tooltip } from '@mui/material';
import printIcon from '../../../../../assets/SVG/printer.svg';

const PrintButton = ({ onClick }: { onClick: () => void }) => (
  <Box mr={2}>
    <Tooltip title="Print">
      <img
        src={printIcon}
        alt="Print Icon"
        onClick={onClick}
        style={{ cursor: 'pointer', marginRight: '4px' }}
      />
    </Tooltip>
  </Box>
);

export default PrintButton;
